<template>
  <div class="ht-tab-wrap">
    <b-tabs class="ht-tab-menu wow move-up">
      <b-tab title="服務方案" active>
        <!-- tab content one component -->
        <TabContentOne />
      </b-tab>
      <!-- <b-tab title="Our mission">
        <TabContentTwo />
      </b-tab> -->
      <b-tab title="客戶服務">
        <!-- tab content third component -->
        <TabContentThree />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import TabContentOne from "./TabContent/TabContentOne";
// import TabContentTwo from "./TabContent/TabContentTwo";
import TabContentThree from "./TabContent/TabContentThree";

export default {
  name: "TabOne",
  components: {
    TabContentOne,
    // TabContentTwo,
    TabContentThree,
  },
};
</script>

<style scoped>
.ht-tab-menu .nav-tabs li a {
  font-size: 1.1rem !important;
}
</style>